<template>
  <el-dialog
    v-if="dialogSwitch"
    :visible.sync="dialogSwitch"
    :close-on-click-modal="false"
    class="dialogBox"
    width="734px"
    :show-close="false"
    :modal-append-to-body="false">
    <!-- <svg class="closeIcon cursor" aria-hidden="true" @click="dialogSwitch = false">
      <use xlink:href="#icon-a-Property1shibai" />
    </svg> -->
    <h3 class="messageTitle">创建成功</h3>
    <div class="messageContent">
      <div style="text-align: left; margin-bottom: 20px;">“{{appName}}”应用已成功创建，应用的上架情况如下：</div>
      <table>
        <thead>
          <tr>
            <th>华为</th>
            <th>OPPO</th>
            <th>vivo</th>
            <th>小米</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><i v-if="data['huawei']" class="el-icon-success" style="color: green;"></i></td>
            <td><i v-if="data['OPPO']" class="el-icon-success" style="color: green;"></i></td>
            <td><i v-if="data['vivo']" class="el-icon-success" style="color: green;"></i></td>
            <td><i v-if="data['xiaomi']" class="el-icon-success" style="color: green;"></i></td>
          </tr>
        </tbody>
      </table>
      <div class="confirm" @click="close()">好的</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props:['error'],
  data() {
    return {
      dialogSwitch: false,
      appName:'',
      data:{
      },
    };
  },
  methods: {
    open(appName,data) {
      this.appName=appName
      this.dialogSwitch = true;
      this.data=data;

    },
    close(){
      this.dialogSwitch = false;
      this.$router.push({
        path:"/console/appLink/app/list",

      });
  
    }
  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
  }
  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 30px;
    height: 30px;
  }
  .messageTitle {
    position: relative;
    margin-bottom: 40px;
    font-size: 20px;
    color: rgba(18, 18, 18, 1);
    text-align: center;

  }
  table{
    width: 500px;
    height: 100px;
    border:1px solid #000;
    th{
      height: 50px;
      border:1px solid #000
    }
    td{
      width: 166px;
      text-align: center;
      border:1px solid #000
    }
    .el-icon-success{
      font-size: 24px;
    }
  }
  .messageContent {
    padding: 0 50px;
    padding-bottom: 30px;
    font-size: 16px;

    .confirm {
      margin: 30px auto;
      width: 331px;
      height: 50px;
      background: #2E84FC;
      border-radius: 5px;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      &:hover {
        opacity: .7;
      }
    }
  }
}

</style>
